"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataObjectReference = exports.DataObject = void 0;
const index_1 = require("../Base/index");
/**
 * Contains a BPMN DataObject.
 * DataObjects are used to store global process informations.
 */
class DataObject extends index_1.BaseElement {
}
exports.DataObject = DataObject;
/**
 * Contains a reference to a DataObject.
 */
class DataObjectReference extends index_1.BaseElement {
}
exports.DataObjectReference = DataObjectReference;
//# sourceMappingURL=DataObject.js.map